import { CSSProperties } from "react";

export interface SpinnerProps {
  size?: string;
  color?: string;
  className?: string;
}

const Spinner = ({
  size = "0.3rem",
  color = "var(--primary)",
  className = "spinner",
}: SpinnerProps) => {
  const borderWidth = `calc(${size} * 1.1)`;
  const spinnerSize = `calc(${size} * 10)`;

  const style: CSSProperties = {
    width: spinnerSize,
    height: spinnerSize,
    borderWidth,
    borderStyle: "solid",
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: "transparent",
  };

  return (
    <div aria-hidden="true" className={`relative inline-block animate-spin rounded-full ${className}`} style={style} />
  );
};

export default Spinner;
